<template>
  <div class="pa-2" style="font-size:0.9em; text-align: justify;">
    <strong>Responsable del tratamiento:</strong> {{ legalName }} <br><strong>Finalidad:</strong> Para formalizar 
    el alta como usuario en la web de Confirming y enviarte productos y servicios comercializados por nuestra Entidad.  
    No se tomarán decisiones automatizadas en base a dicho perfil. <br><strong>Legitimación:</strong>  Los  datos  se  tratan  en 
    base a la ejecución de su solicitud, contrato, o precontrato, mediante la inscripción en la web de Confirming.  
    Los tratamientos adicionales están basados en el interés legítimo del responsable del tratamiento.<br>
    <strong>Destinatarios:</strong> No se cederán datos a terceros salvo obligación legal. Los datos se conservarán 
    mientras sean necesarios para el mantenimiento de la relación contractual.
    <br><strong>Derechos:</strong> Como titular de los datos, tiene derecho a acceder, actualizar, rectificar y suprimir 
    los datos, así como otros derechos, dirigiéndose a {{ shortName }} con domicilio social en
    {{ address }}, o en la dirección de correo electrónico {{ email }}. <br><strong>Información Adicional:</strong>
    Puede consultar información adicional y detallada sobre protección de datos en la
    <a target="_blank" :href="entityConfig.privacyPolicyUrl"
      >Política de Privacidad de la Web Confirming.</a
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      entityConfig: {},
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
  },
  computed: {
    legalName() {
      return this.entityConfig?.firsInfoLayer?.legalName || "NOMBRE LEGAL";
    },
    shortName() {
      return this.entityConfig?.firsInfoLayer?.shortName || "la entidad";
    },
    address() {
      return this.entityConfig?.firsInfoLayer?.address || "DIRECCION";
    },
    email() {
      return this.entityConfig?.firsInfoLayer?.email || 'EMAIL';
    }
  },
};
</script>